import React, { Component } from 'react';
import ProjectCards from './ProjectCards'

import ImagePhar from '../images/ImagePharm.png'
import ImageDoc from '../images/ImageDoc.png'
import ImageMkulima from '../images/ImageMkulima.png'
import ImageMovie from '../images/ImageMovie.png'

class Projects extends Component {
    render() {
        return (
            <>
                <div className="col-10 p-3 my-3 mx-auto projects img-thumbnail" id="projects">
                    <h4 className='title'>Projects:</h4>
                    <p className="lead">Below Are Some Of My Projects: </p>
                <div className="row">
                    <ProjectCards
                        Image = {ImagePhar}
                        ProjectTitle = "Pharmarcy Inventory"
                        LiveLink= "https://pharmacy-inventory.netlify.app/"
                        GitLink = "https://github.com/GeorgeGithiri5/Pharmacy-Inventory-MERN"
                    />
                    <ProjectCards
                        Image = {ImageMkulima}
                        ProjectTitle = "Mkulima"
                        LiveLink= "https://mkulima.netlify.app/"
                        GitLink = "https://github.com/GeorgeGithiri5/mkulima"
                    />
                </div>
                <div className="row">
                    <ProjectCards
                        Image = {ImageDoc}
                        ProjectTitle = "Doctor AppointMent"
                        LiveLink= "https://doctor-appointment.netlify.app/"
                        GitLink = "https://github.com/GeorgeGithiri5/Doctor-Appointment"
                    />
                    <ProjectCards
                        Image = {ImageMovie}
                        ProjectTitle = "MovieShop"
                        LiveLink= "https://online-movieshop-project.netlify.app/"
                        GitLink = "https://github.com/GeorgeGithiri5/OnlineMovieShop"
                    />
                </div>
                </div>
            </>
        );
    }
}

export default Projects;